import { eGENA_Item } from "./Item";
import { eGENA_ItemListElement } from "./ItemListElement";
import { eGENA_KarteireiterTyp } from "./KarteireiterTyp";


/** Eine Item-Liste entspricht einem Karteireiter auf der "linken Seite" und besteht, welch Wunder, aus einer Liste
 *  von Items und optional aus den Gruppen, denen die Icons der Liste zugeordnet sein können.
 * 	Eine Gruppe fasst einfach eine Reihe von Items zusammen und kann, unter Darstellung ihres Namens, ein- und ausgeklappt werden.
 *
 *	Die Liste der Items ist hier doppelt gemoppelt gespeichert:
 *	- "items": diese Liste repräsentiert die Daten wie sie vom Editor kommen
 *  - "listenElemente": diese Liste wird aus den "items" generiert. Die einzelnen Elemente haben mehr Attribute
 *	  als die in "items". Die Zusatzattribute werden von der App benötigt.
 *  Je nach Zweck ist einmal das eine und einmal das andere vorhanden.
 */
export class eGENA_ItemListe {
	public typ : eGENA_KarteireiterTyp;
	public items : eGENA_Item[] | undefined;
	public listenElemente : eGENA_ItemListElement[] | undefined = undefined;


	constructor(typ : eGENA_KarteireiterTyp, items : eGENA_Item[] | undefined) {
		this.typ = typ;
		this.items = items;
	}


	/* Hier bearbeiten wir ein Array von untypisierten Objekten.
	 * Jedes Objekt repräsentiert einen Karteireiter.
	 */
	public static fromJSONarray(objects : any[]) : eGENA_ItemListe[] {
		let result : eGENA_ItemListe[] = [];

		for (const object of objects) { 
			if (!('typ' in object)) {
				throw new Error("JSON-String: " + JSON.stringify(object, null, 4) + "\n\neGENA_ItemListe.fromJSONarray@1: Der JSON-String ist nicht im erwarteten Format: Das Attribut 'typ' ist nicht definiert.");
			}
			let items : eGENA_Item[] | undefined = undefined;
			if ('items' in object) {
				items = eGENA_Item.fromObjectArray(object.items);    //object.items
			}
			let itemListe : eGENA_ItemListe = new eGENA_ItemListe(object.typ, items);

			if ('listenElemente' in object) {
				itemListe.listenElemente = eGENA_ItemListElement.fromJSONarray(object.listenElemente);
			}

			result.push(itemListe);
		}

		return result;
	}
}



// WEBPACK FOOTER //
// ./src/visionet/ItemListe.ts